import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { StateDisplayerType } from "../state-displayer/state-displayer.component";
import { UserRightsService } from "../../../services/user-rights.service";

@Component({
  selector: "app-state-displayer-skeleton-line",
  templateUrl: "./state-displayer-skeleton-line.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./state-displayer-skeleton-line.component.scss"]
})
export class StateDisplayerSkeletonLineComponent implements OnInit {
  @Input() type: StateDisplayerType;

  constructor(private _userRightsService: UserRightsService) {}

  ngOnInit(): void {}

  protected isAdmin(event: string): boolean {
    return this._userRightsService.getUserRightLevel(event);
  }
}
